import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function HostingServices() {
  const faqs = [
    {
      question: "What web hosting solutions does Mokshiq provide?",
      answer: "Mokshiq (Rakle Service Private Limited) provides Linux cPanel Hosting, Windows Plesk Hosting, Reseller Hosting, and Managed Cloud VPS / Dedicated Servers."
    },
    {
      question: "What is the server uptime guarantee?",
      answer: "We guarantee 99.9% network uptime backed by tier-4 data centers with DDOS protection and automatic daily backups."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-server me-2"></i>Infrastructure &amp; Hosting
            </span>
            <h1 className="page_title text-white mb-3">Linux, Windows &amp; Cloud VPS Hosting</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              High-speed NVMe SSD web hosting and enterprise cloud server management by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Services</a></li>
              <li className="active"><a href="#!">Hosting Services</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-brands fa-linux text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Linux cPanel Hosting</h3>
                  <p className="text-muted small">PHP 8.x, MySQL, free SSL certificates, 1-click WordPress install, and softaculous auto-installer.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-brands fa-windows text-info fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Windows Plesk Hosting</h3>
                  <p className="text-muted small">ASP.NET Core, MSSQL Database, IIS Web Server, and dedicated application pool support.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-cloud text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">VPS &amp; Dedicated Server</h3>
                  <p className="text-muted small">Dedicated CPU cores, RAM, root SSH access, hardware firewall, and 10Gbps network connectivity.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Hosting Services FAQs" subtitle="Frequently asked questions about web hosting and cloud infrastructure." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default HostingServices;
